import React, { useState } from "react";
import { RouteProps } from "react-router";
import Content from "Types/Content";
import GameModal from "./components/GameModal";
import Game from "./Game";
import "./styles.scss";

type GameConfigProps = {
  sound?: boolean;
  size?: number;
  bombs?: number;
};

const Minesweeper: React.FC<RouteProps> = () => {
  const [zoom, setZoom] = useState(1.3);
  const [modalOpen, setModalOpen] = useState(false);
  const [gameConfig, setGameConfig] = useState<GameConfigProps>({
    sound: true,
    size: 8,
    bombs: 8
  });
  function handleZoom(more: boolean) {
    setZoom(prev => {
      if (more && prev + 0.3 < 2) return prev + 0.3;
      if (!more && prev - 0.3 > 0.9) return prev - 0.3;
      return prev;
    });
  }
  function handleConfig(value: GameConfigProps) {
    setGameConfig(prev => ({ ...prev, ...value }));
  }
  function validate() {
    setGameConfig(prev => {
      const final = prev;
      if (!final.bombs || final.bombs < 0) final.bombs = 0;
      if (final.bombs > 127) final.bombs = 127;
      if (!final.size || final.size < 8) final.size = 8;
      if (final.size > 64) final.size = 64;
      return final;
    });
  }
  return (
    <div className='example-buscaminas-content'>
      <GameModal
        title='Configuración'
        visible={modalOpen}
        onClickClose={() => setModalOpen(false)}>
        <p className='subtitle'>Configuración general</p>
        <div className='modal-row'>
          <p>Sonido</p>
          <button
            onClick={() => handleConfig({ sound: !gameConfig.sound })}
            name='sound'
            className='button square checkbox'>
            {gameConfig.sound ? "✓" : ""}
          </button>
        </div>
        <p className='subtitle'>Configuración del juego</p>
        <div className='modal-row'>
          <p>
            Tamaño <small>(experimental)</small>
          </p>
          <input
            className='textbox tiny'
            type='number'
            maxLength={2}
            min={8}
            max={64}
            defaultValue={gameConfig.size}
            onBlur={validate}
            onFocus={validate}
            onChange={e => handleConfig({ size: Number(e.target.value) })}
          />
        </div>
        <div className='modal-row'>
          <p>Bombas</p>
          <input
            className='textbox tiny'
            type='number'
            maxLength={3}
            min={0}
            max={127}
            defaultValue={gameConfig.bombs}
            onBlur={validate}
            onFocus={validate}
            onChange={e => handleConfig({ bombs: Number(e.target.value) })}
          />
        </div>
        <p className='info'>Reiniciá juego para aplicar los nuevos cambios</p>
        <button
          className='button'
          onClick={() => {
            setModalOpen(false);
            validate();
          }}>
          Aceptar
        </button>
      </GameModal>
      <div className='panel invert'>
        <button className='button square' onClick={() => handleZoom(false)}>
          ➖
        </button>
        <p>ZOOM</p>
        <button className='button square' onClick={() => handleZoom(true)}>
          ➕
        </button>
        <div className='separator' />
        <button className='button square' onClick={() => setModalOpen(true)}>
          ⚙️
        </button>
      </div>
      <Game
        zoom={zoom}
        size={gameConfig.size || 8}
        bombs={gameConfig.bombs || 0}
        sound={Boolean(gameConfig.sound)}
      />
      <div className='firma'>
        <p>Juan Becchio</p>
        <p>Todos los derechos reservados (?)</p>
      </div>
    </div>
  );
};

export default new Content({
  Component: Minesweeper,
  title: "Buscaminas",
  route: "buscaminas"
});
